import { css } from '@emotion/react';
import { atoms } from '@zapier/marketing-ui';
import { Icon } from '@zapier/zinnia-icons';
import { FC, ReactNode } from 'react';
import { VisuallyHidden } from 'react-aria-components';

const requirementStyle = css`
  display: flex;
  align-items: start;
  gap: var(--zds-space-4);
`;

/** Text for the state the aria-hidden icons convey (SC 1.1.1). */
export const requirementMetLabel = 'Met:';
export const requirementNotMetLabel = 'Not met:';

type PasswordRequirementProps = {
  children: ReactNode;
  requirementIsSatisfied?: boolean;
  testId: string;
};

const PasswordRequirement: FC<PasswordRequirementProps> = ({
  children,
  requirementIsSatisfied,
  testId,
}) => {
  const name = requirementIsSatisfied ? 'formCheck' : 'formX';
  const color = requirementIsSatisfied
    ? 'StatusSuccessStrongest'
    : 'StatusErrorStrongest';

  return (
    <div data-testid={testId} css={requirementStyle}>
      <Icon name={name} color={color} size={20} />
      {/* design-contract: floor exception on text — marketing-ui atoms, not Zinnia Text,
          because this published package doesn't depend on @zapier/design-system. */}
      <p className={`${atoms.bodySM} ${atoms.textNeutral800}`}>
        <VisuallyHidden elementType="span">
          {requirementIsSatisfied
            ? `${requirementMetLabel} `
            : `${requirementNotMetLabel} `}
        </VisuallyHidden>
        {children}
      </p>
    </div>
  );
};

export default PasswordRequirement;
